import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=8e81eca8"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e81eca8')) {
      api.createRecord('8e81eca8', component.options)
    } else {
      api.reload('8e81eca8', component.options)
    }
    module.hot.accept("./Draggable.vue?vue&type=template&id=8e81eca8", function () {
      api.rerender('8e81eca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/Draggable.vue"
export default component.exports